export enum ActionType {
  COPY = 'COPY',
  MOVE = 'MOVE',
}
